import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SelectInput, { findItem } from 'Components/forms/select-input/SelectInput.jsx';
import TextField from 'Components/forms/text-field/TextField';
import QueueView from 'Components/QueueView';
import Search from '../search/Search.jsx';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import Label from 'Components/forms/label/Label';
import { getUserGroups, getGroupAnalystDetails, getGroupCasesCount } from 'Apis/queueManagerApi.js';
import EmptyState from 'Components/EmptyState/EmptyState';
import counterpart from 'counterpart';
import './GroupSearch.scss';

class GroupSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [
        {
          value: 0,
          text: this.props.defaultGroupTitle,
        },
      ],
      currentSearchTerm: '',
      currentGroup: {
        value: 0,
        text: this.props.isGroupPresent ? this.props.groupNotAvailableMessage : this.props.defaultGroupTitle,
      },
      currentGroupAnalysts: [],
      currentFilteredAnalysts: [],
      dataErr: false,
      isLoading: true,
      groupCaseCountFlag: true
    }

    this.attachBindings();
  }

  attachBindings() {
    this.selectGroup = this.selectGroup.bind(this);
    this.gotoQueueLanding = this.gotoQueueLanding.bind(this);
    this.searchAnalysts = this.searchAnalysts.bind(this);
    this.fetchUserGroups = this.fetchUserGroups.bind(this);
    this.fetchGroupAnalystsDetails = this.fetchGroupAnalystsDetails.bind(this);
    this.fetchGroupCasesCount = this.fetchGroupCasesCount.bind(this);
    this.setUniqueGroupAnalysts = this.setUniqueGroupAnalysts.bind(this);
    this.getAcquirerAccessList = this.getAcquirerAccessList.bind(this);
  }

  componentWillMount() {
    this.fetchUserGroups();
    let acquirer=this.getAcquirerAccessList();
    this.fetchGroupAnalystsDetails(null,acquirer);
  }

  getAcquirerAccessList() {
    let userMXPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
      .parsedPermissions.queue.viewMxQueues;
    let userGPPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
      .parsedPermissions.queue.viewGPNQueues;
    let userHPYPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
      .parsedPermissions.queue.viewHPYQueues;
    let userEVOPermissions = JSON.parse(sessionStorage.getItem("state")).auth.user
      .parsedPermissions.queue.viewEvoQueues;
  
    var acquirerAccess = new Array();
  
    if (userMXPermissions) {
      acquirerAccess.push("MXP");
      acquirerAccess.push("MXI");
    }
    if (userGPPermissions) {
      acquirerAccess.push("GPN");
    }
    if (userHPYPermissions) {
      acquirerAccess.push("HPY");
    }
    if (userEVOPermissions) {
      acquirerAccess.push("EMD");
      acquirerAccess.push("EMI");
    }
    return acquirerAccess;
  } 

  fetchUserGroups() {
    let userGroups = [];
    let acquirerAccessList=this.getAcquirerAccessList();
    return getUserGroups(acquirerAccessList)
      .then((apiResponse) => {
        apiResponse.data.forEach(group => {
          let groupItem = {
            value: group.userGroupId,
            text: group.userGroupName,
            acquirer: group.acquirerCode,
          }
          userGroups = userGroups.concat([groupItem]);
        });
        let stateGroups = [...this.state.groups];
        stateGroups = stateGroups.concat(userGroups);
        this.setState({
          groups: stateGroups,
          dataErr: this.props.isGroupPresent ? true : false,
          isLoading: false
        });
      })
      .catch((error) => {
        this.setState({ dataErr: true, isLoading: false });
        console.log('Error occured while fetching user groups: ', error);
      });
  }

  fetchGroupAnalystsDetails(userGroupId, acquirer) {
    return getGroupAnalystDetails(userGroupId, acquirer)
      .then((apiResponse) => {
        this.setState({ dataErr: false, isLoading: false });
        this.setUniqueGroupAnalysts(apiResponse.data);
      })
      .catch((error) => {
        this.setState({ dataErr: true, isLoading: false });
        console.log('Error occured while fetching user details: ', error);
      });
  }
  /**
   * This method is responsible for set Unique Group analyst 
   * @param {} currentGroupAnalysts 
   */
  setUniqueGroupAnalysts(currentGroupAnalysts) {
    let uniqueGroupAnalyst = [];
    for (let i = 0; i < currentGroupAnalysts.length; i++) {
      if (uniqueGroupAnalyst.findIndex((analyst) => { return analyst.userId == currentGroupAnalysts[i].userId }) == -1) {
        uniqueGroupAnalyst.push(currentGroupAnalysts[i]);
      }
    }
    this.setState({
      currentGroupAnalysts: uniqueGroupAnalyst,
    })
  }
  fetchGroupCasesCount(userGroupId, acquirer) {
    return getGroupCasesCount(userGroupId, acquirer)
      .then((apiResponse) => {
        this.props.fetchAssignedCasesCount(apiResponse.data);
        this.setState({ dataErr: (apiResponse.data.availableToWorkCount==0) ? true : false, isLoading: false, groupCaseCountFlag: apiResponse.data.availableToWorkCount > 0 });
      })
      .catch((error) => {
        this.setState({ dataErr: true, isLoading: false });
        console.log('Error occured while fetching assigned cases count: ', error);
      })
  }

  selectGroup(value) {
    const groups = this.state.groups;
    const selectedGroup = findItem(groups, value);
    if (selectedGroup) {
      this.setState({ currentGroup: selectedGroup });
      let groupId;
      let acquirer;
      if (selectedGroup.value === 0) {
        groupId = null;
        acquirer = this.getAcquirerAccessList();
      } else {
        groupId = selectedGroup.value;
        acquirer = selectedGroup.acquirer;
      }
      this.fetchGroupAnalystsDetails(groupId, acquirer);
      this.fetchGroupCasesCount(groupId, acquirer);
    }
  }

  gotoQueueLanding(userId) {
    this.props.history.push(`/queue-management-landing?userid=${userId}`);
  }

  
  searchAnalysts(value) {
    this.setState({
      currentSearchTerm: value,
    });
  }

  get displayAnalysts() {
    return (<ul className="analyst-group-list">
      {this.state.currentGroupAnalysts.map((analyst, index) => {
        const trimmedFullName = `${analyst.firstName} ${analyst.lastName}`.toLowerCase().replace(/\s+/g, '');
        const trimmedSearchTerm = this.state.currentSearchTerm.toLowerCase().replace(/\s+/g, '');
        const rowLen = this.state.currentGroupAnalysts.length;
        return (this.state.groupCaseCountFlag) && (trimmedFullName.includes(trimmedSearchTerm)) && (<li
          className="analyst-card"
          key={index}
        >
          <QueueView
            id={analyst.userId}
            name={`${analyst.firstName} ${analyst.lastName}`}
            onViewClick={() => this.gotoQueueLanding(analyst.userId)}
            count={analyst.assignedCasesCount}
            isBorder={rowLen === index + 1 ? true : false}
          />
        </li>);
      })}
    </ul>);
  }

  render() {
    return (
      <div className="group-search-wrapper">
        {
          this.state.isLoading && <BVLoader20 />
        }
        {this.state.groups.length > 0 && <div className='group-top'>
          <div className='group-dropdown'>
            <TextField
              htmlFor="Groups"
              labelContent={<span data-radium>
                <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }}
                  htmlFor="Groups Label"
                  labelClass="field-label checkbox-group-parent-label">
                  {this.props.selectionTitle}
                </Label>
              </span>}
            >
              <SelectInput
                selectClass={{ zIndex: 1 }}
                dataList={this.state.groups}
                wrapperClass="select-menu__form reports field-input"
                extraClass="analystLabel-text-dropdown"
                handleSelection={this.selectGroup}
                selectedItem={this.state.currentGroup}
                isDisabled={this.props.isGroupPresent}
              />
            </TextField>
          </div>
          <div className='analyst-search'>
            <TextField
              htmlFor="Search"
              labelContent={<span data-radium>
                <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }}
                  htmlFor="Search Label"
                  labelClass="field-label checkbox-group-parent-label">
                  {this.props.searchTitle}
                </Label>
              </span>}
            >
              <div className='autocomplete'>
                <Search
                  filterText={this.state.currentSearchTerm}
                  onChange={this.searchAnalysts}
                  placeholder={this.props.searchPlaceholder}
                />
              </div>
            </TextField>
          </div>
        </div>
        }
        <div className="group-bottom">
          {this.displayAnalysts}
        </div>
        {
          this.state.dataErr && !this.state.isLoading &&
          <EmptyState
            translations={{
              emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'),
              emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription')
            }}
          />
        }
      </div>
    );
  }
}


GroupSearch.propTypes = {
  defaultGroupTitle: PropTypes.string,
  selectionTitle: PropTypes.string,
  searchTitle: PropTypes.string,
  searchPlaceholder: PropTypes.string,
};

GroupSearch.defaultProps = {
  defaultGroupTitle: 'All Analysts',
  selectionTitle: 'Groups',
  searchTitle: 'Search',
  searchPlaceholder: 'Search Analyst',
};

export default withRouter(GroupSearch);
